var _circle, _path, _path2, _path3, _path4, _path5;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgLoginMetric(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20.6667,
    r: 20,
    fill: "#CED2E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0004 30.5334L10.4004 30.5334L10.4004 28.9734L29.0004 28.9734L29.0004 30.5334Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2012 13.1332L27.2012 27.5332L24.2012 27.5332L24.2012 13.1332L27.2012 13.1332Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 16.7332L23 27.5332L20 27.5332L20 16.7332L23 16.7332Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8008 18.7332L18.8008 27.5332L15.8008 27.5332L15.8008 18.7332L18.8008 18.7332Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5996 23.3334L14.5996 27.5334L11.5996 27.5334L11.5996 23.3334L14.5996 23.3334Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginMetric);
export default __webpack_public_path__ + "static/media/login-metric.3fd47ffb2f2509483fa816ca9609d5cd.svg";
export { ForwardRef as ReactComponent };